import { useEffect, useRef } from 'react';
import lottie, { type AnimationItem } from 'lottie-web/build/player/lottie_light';
import spinnerData from '@/assets/gemini-spinner.json';
import starData from '@/assets/gemini-star.json';

export default function GeminiLoader({ size = 28 }: { size?: number }) {
  const spinnerRef = useRef<HTMLDivElement>(null);
  const starRef = useRef<HTMLDivElement>(null);
  const animsRef = useRef<{ spinner?: AnimationItem; star?: AnimationItem }>({});

  useEffect(() => {
    if (spinnerRef.current && !animsRef.current.spinner) {
      animsRef.current.spinner = lottie.loadAnimation({
        container: spinnerRef.current,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: spinnerData,
      });
    }
    if (starRef.current && !animsRef.current.star) {
      animsRef.current.star = lottie.loadAnimation({
        container: starRef.current,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: starData,
      });
    }
    return () => {
      animsRef.current.spinner?.destroy();
      animsRef.current.star?.destroy();
      animsRef.current = {};
    };
  }, []);

  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }}>
      <div ref={spinnerRef} className="absolute inset-0" />
      <div ref={starRef} className="absolute inset-0" />
    </div>
  );
}
